export const PHRASE_STORAGE_KEY = 'chat-rea.console.phrases';
export const DEFAULT_PHRASES = ['大家好', '有人在嗎', '安安，在忙嗎？'];
export function parsePhrases(raw) {
    if (raw === null)
        return DEFAULT_PHRASES;
    try {
        const value = JSON.parse(raw);
        if (!Array.isArray(value))
            return DEFAULT_PHRASES;
        return value.filter((item) => typeof item === 'string' && item.trim() !== '');
    }
    catch {
        return DEFAULT_PHRASES;
    }
}
export function readPhrases(storage) {
    if (!storage)
        return DEFAULT_PHRASES;
    try {
        return parsePhrases(storage.getItem(PHRASE_STORAGE_KEY));
    }
    catch {
        return DEFAULT_PHRASES;
    }
}
export function writePhrases(storage, phrases) {
    if (!storage)
        return;
    try {
        storage.setItem(PHRASE_STORAGE_KEY, JSON.stringify(phrases));
    }
    catch {
        // 隱私模式或容量滿：這一頁照常用記憶體裡的片語。
    }
}
export function addPhrase(phrases, text) {
    const phrase = text.trim();
    if (phrase === '' || phrase.startsWith('/') || phrases.includes(phrase))
        return phrases;
    return [...phrases, phrase];
}
export function removePhrase(phrases, text) {
    return phrases.filter((item) => item !== text);
}
//# sourceMappingURL=phraseBook.js.map